import React from 'react';
import { Card } from '../../../components/Card/Card';
import { t } from '../../../locales/translate';
import './WarningCard.css';

interface WarningCardProps {
  children: React.ReactNode;
}

export function WarningCard({ children }: WarningCardProps): JSX.Element {
  return (
    <Card title={t.general.warning} className="warning-card">
      {children}
    </Card>
  );
}
